import React from "react";
import cx from "classnames";
// import PropTypes from 'prop-types'
import { PrivilegeStyled } from "./styled";
import { IMG_PATH } from "utils/constants/imgPath";
import { Displays } from "components";

const Privilege = ({ theme_standard, title, subtitle, date, src }) => {
  const customClass = cx({
    theme_standard: theme_standard,
  });
  return (
    <PrivilegeStyled className={customClass}>
      <div className="figture_img">
        <Displays.ImageSmooth
          src={src ? IMG_PATH + src : "/assets/images/mockups/privilege.png"}
          aspectRatio="18 / 7"
        />
      </div>

      <div className="privilege_title">{title}</div>
      <div className="privilege_subtitle">{subtitle}</div>
      <div className="privilege_date">{date}</div>
    </PrivilegeStyled>
  );
};

Privilege.propTypes = {};

export default Privilege;
